"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = void 0;
// For more information about this file see https://dove.feathersjs.com/guides/cli/client.html
const feathers_1 = require("@feathersjs/feathers");
const authentication_client_1 = __importDefault(require("@feathersjs/authentication-client"));
const keys_shared_1 = require("./services/keys/keys.shared");
const users_shared_1 = require("./services/users/users.shared");
const radiostatus_shared_1 = require("./services/radiostatus/radiostatus.shared");
const radiolog_shared_1 = require("./services/radiolog/radiolog.shared");
const calltime_shared_1 = require("./services/calltime/calltime.shared");
const transcription_shared_1 = require("./services/transcription/transcription.shared");
const talkgroups_shared_1 = require("./services/talkgroups/talkgroups.shared");
const srclist_shared_1 = require("./services/srclist/srclist.shared");
const radio_ids_shared_1 = require("./services/radio-ids/radio-ids.shared");
const freqlist_shared_1 = require("./services/freqlist/freqlist.shared");
const calls_shared_1 = require("./services/calls/calls.shared");
/**
 * Returns a typed client for the OinkDB app.
 *
 * @param connection The REST or Socket.io Feathers client connection
 * @param authenticationOptions Additional settings for the authentication client
 * @see https://dove.feathersjs.com/api/client.html
 * @returns The Feathers client application
 */
const createClient = (connection, authenticationOptions = {}) => {
    const client = (0, feathers_1.feathers)();
    client.configure(connection);
    client.configure((0, authentication_client_1.default)(authenticationOptions));
    client.set('connection', connection);
    client.configure(calls_shared_1.callsClient);
    client.configure(freqlist_shared_1.freqListClient);
    client.configure(radio_ids_shared_1.radioIdsClient);
    client.configure(srclist_shared_1.srclistClient);
    client.configure(talkgroups_shared_1.talkgroupsClient);
    client.configure(transcription_shared_1.transcriptionClient);
    client.configure(calltime_shared_1.calltimeClient);
    client.configure(radiolog_shared_1.radiologClient);
    client.configure(radiostatus_shared_1.radiostatusClient);
    client.configure(users_shared_1.userClient);
    client.configure(keys_shared_1.apiKeysClient);
    return client;
};
exports.createClient = createClient;
